/**
 * Basic show/hide behaviors, wired up on every page by site-v3.js.
 * These only set attributes - the visual work lives in _expand-and-reveal.scss,
 * _expanding-section-mobile.scss and the site header styles.
 */

/**
 * Sections that toggle open and closed, e.g. the mobile accordions on /about/.
 * Toggles `data-expanded` on each `[data-expandable]` when a
 * `[data-expandable-trigger]` inside it is clicked.
 */
export function WireupExpanders() {
    for (const section of document.querySelectorAll("[data-expandable]")) {
        for (const trigger of section.querySelectorAll("[data-expandable-trigger]")) {
            trigger.addEventListener("click", () => section.toggleAttribute("data-expanded"));
        }
    }
}

/**
 * One-way "show more" triggers. Clicking a `[data-reveal-trigger]` adds `data-revealed`
 * to every region whose `data-reveal-target-id` matches the trigger's `data-reveal-target`.
 * This is kind of a duplicate of <text-revealer> but works on pages without it loaded.
 */
export function WireupRevealers() {
    for (const trigger of document.querySelectorAll("[data-reveal-trigger]")) {
        const targetId = trigger.dataset.revealTarget;
        trigger.addEventListener("click", (e) => {
            e.stopPropagation();
            // Mark the trigger itself so it can be hidden once it has been used
            e.currentTarget.setAttribute("data-reveal-trigger-clicked", "");
            for (const region of document.querySelectorAll(`[data-reveal-target-id="${targetId}"]`)) {
                region.setAttribute("data-revealed", "");
            }
        });
    }
}

/**
 * The header's expanding mobile menu. Only rendered for signed-in users,
 * so this is a no-op when signed out.
 */
export function WireupMobileMenu() {
    const menu = document.querySelector("[data-mobile-menu-target]");
    if (!menu) return;
    for (const toggle of document.querySelectorAll("[data-toggle-menu]")) {
        toggle.addEventListener("click", () => menu.toggleAttribute("data-expanded"));
    }
}
